// extracted by mini-css-extract-plugin
module.exports = {"marquee":"Marquee_marquee__eeMe_","marquee-content":"Marquee_marquee-content__KBzeQ","marqueeAnimation":"Marquee_marqueeAnimation__04pyA","load":"Marquee_load__nivQJ"};